query LatestBanner {
    latest_banner {
        id
        text
        url
        label
    }
}
